import { SVGPureIcon } from '@/ui';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';

const FoldBtn = observer(({ 
  text = '', 
  tips = '',
  onClick, 
  iconName = '', 
  className = '', 
  textClassName = "", 
  iconClassName = "", 
  small, 
  circle,
  isMcpAgent,
}) => {
  return (
    <Tooltip title={tips ?? (small && !isMcpAgent ? text : '')}>
      <div
        onClick={() => onClick?.()}
        className={[
          'flex items-center h-36px',
          small ? 'w-32px flex items-center justify-center' : 'px-16px py-8px',
          small && !circle ? 'rounded-12px' : 'rounded-full',
          'mr-16px text-primary-opacity text-opacity-90 cursor-pointer',
          'border-1px border-black border-opacity-16',
          'bg-button-bg-normal hover:bg-[#f7f7f7]',
          className,
        ]}
      >
        <SVGPureIcon name={iconName} className={`size-16px ${small ? '' : 'mr-4px'} ${iconClassName}`} />
        {
          small
          ? null
          : <span className={`text-14px ${textClassName}`}>{text}</span>
        }
      </div>
    </Tooltip>
  );
});

export default FoldBtn;